import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    id_role: null,
    id_avn_user: null,
    id_user: null,
    isAuth: false
};
export const authSlice = createSlice({
    initialState,
    name: 'auth',
    reducers: {
        accessAuth: (state, action) => {
            const { isAuth, id_user, id_avn_user, id_role } = action.payload;
            state.isAuth = isAuth;
            state.id_user = id_user;
            state.id_avn_user = id_avn_user;
            state.id_role = id_role;
        },
        clearData: state => {
            state.isAuth = false;
            state.id_user = null;
            state.id_avn_user = null;
            state.id_role = null;
        },
        //id role Деконат = 3
        role3: state => {
            state.id_role = 3;
        },
        role4: state => {
            state.id_role = 4;
        },
        role1: state => {
            state.id_role = 1;
        }
    },
    extraReducers: {}
});
export default authSlice.reducer;
